const ALIGNMENTS = {
  center: 'center',
  left: 'left',
  right: 'right',
};

const QUESTIONS = {
  acceptQuestion: 'acceptQuestion',
  cancelQuestion: 'cancelQuestion',
  disposalQuestion: 'disposalQuestion',
  regretQuestion: 'regretQuestion',
  oneWeekQuestion: 'oneWeekQuestion',
};

const SECTION_TYPES = {
  question: 'question',
  information: 'information',
};

class InfoAndQuestions {
  constructor(params) {
    this.error = params.error;
    this.serviceId = params.serviceId;
    this.title = params.title;
    this.sections = (params.sections || []).map((section) => {
      switch (section.type) {
        case SECTION_TYPES.question:
          switch (section.question) {
            case QUESTIONS.acceptQuestion:
            case QUESTIONS.cancelQuestion:
            case QUESTIONS.disposalQuestion:
            case QUESTIONS.regretQuestion:
            case QUESTIONS.oneWeekQuestion:
              return {
                type: section.type,
                order: section.order,
                question: section.question,
              };
            default:
              return null;
          }
        case SECTION_TYPES.information:
          return {
            type: section.type,
            order: section.order,
            label: section.label,
            description: section.description,
            descriptionAlignment: section.descriptionAlignment,
            boldDescription: section.boldDescription,
            italicDescription: section.italicDescription,
            underlineDescription: section.underlineDescription,
          };
        default:
          return null;
      }
    });
  }
}

export { InfoAndQuestions, ALIGNMENTS, QUESTIONS, SECTION_TYPES };



// WEBPACK FOOTER //
// ./src/models/InfoAndQuestions.js